import { route } from 'quasar/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory
} from 'vue-router';

import routes from './routes';
import { useAuthStore } from '@/stores/auth';
import { trackEvent } from '@/boot/analytics';

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory;

  const router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    history: createHistory(process.env.VUE_ROUTER_BASE)
  });

  router.beforeEach(async (to) => {
    // On the server, skip auth guard — the client will re-verify after hydration.
    if (process.env.SERVER) return true;

    if (!to.meta.requiresAuth) return true;
    const auth = useAuthStore();
    // boot/auth.ts starts the restore without awaiting it so the app mounts
    // straight away; protected routes are the only ones that must wait for it.
    // Idempotent, and bounded by the store's own timeout.
    await auth.restoreSession();
    if (!auth.isAuthenticated) {
      return { name: 'auth', query: { redirect: to.fullPath } };
    }
    return true;
  });

  router.afterEach((to) => {
    // Track pageviews in Vercel Web Analytics — skipped in SSR and in DEV by trackEvent itself.
    if (process.env.SERVER) return;
    trackEvent('pageview', { path: to.fullPath });
  });

  return router;
});
